import { canAccessRoute } from '@/utils/permissions'
import router from '@/router'

/**
 * Vue directive for conditionally rendering elements based on route permissions
 * Usage: v-route-permission="'route.name'" or v-route-permission="{ name: 'route.name' }"
 */
export default {
  mounted(el, binding) {
    if (!binding.value) {
      console.warn('v-route-permission directive requires a route name')
      return
    }

    // Get route from binding value
    const routeValue = binding.value
    let route

    if (typeof routeValue === 'string') {
      // If route name is provided as string
      route = router.resolve({ name: routeValue })
    } else if (typeof routeValue === 'object') {
      // If route object is provided
      route = router.resolve(routeValue)
    } else {
      console.warn('v-route-permission directive requires a route name or object')
      return
    }

    // Check if user has permission for the route
    const hasPermission = canAccessRoute(route)

    // Hide element if user doesn't have permission
    if (!hasPermission) {
      if (binding.modifiers.hide) {
        el.style.display = 'none'
      } else {
        // Remove element from DOM
        el.parentNode?.removeChild(el)
      }
    }
  }
}
